import { animate, state, style, transition, trigger } from '@angular/animations';

export const expandCollapse = trigger('expandCollapse', [
  state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
  state('expanded', style({ height: '*' })),
  transition('expanded <=> collapsed', animate('300ms cubic-bezier(0.4,0.0,0.2,1)')),
]);
